import {CreatePlan, CreateResult} from "../view-model";
import {StateMachineEvent} from "../state-machine";

export const toStateMachineEvent = (
  plan: CreatePlan,
  result: CreateResult
): StateMachineEvent | undefined => {
  if (result.status === "failed") {
    return {type: "failure", result, source: plan.source};
  } else if (result.status === "created") {
    return {type: "success", result, source: plan.source};
  } else {
    return {type: "progress", result};
  }
};
